module.exports = __webpack_public_path__ + "img/laura-martinez-dental-hygienist.6de95af3.png";